let _ = t => t,
  _t,
  _t2;
import styled from 'styled-components';
export const Wrapper = styled.div(_t || (_t = _`
    position: relative;

    width: 100%;
    max-width: 512px;

    .ovpn-input-trailing-icon {
        margin-left: -16px;

        cursor: pointer;
    }

    .ovpn-dropdown-input-variant {
        cursor: default;
    }
`));
export const IconsContainer = styled.div(_t2 || (_t2 = _`
    display: flex;
    align-items: center;

    max-width: 40px;

    & > svg:last-child {
        margin-left: auto;
    }
`));